import { Box, Button, Grid, Typography } from "@mui/material";
import React from "react";
import ErrorSvg from "src/icons/500Icon";
import IconRain from "src/icons/CyrptoRain";

type Props = {};

const ErrorPage = (props: Props) => {
  const handleReturnClick = () => {
    window.location.href = "/";
  };

  return (
    <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justifyContent="center"
      style={{ minHeight: "100vh", padding: "10px 10px 10px 10px" }}>
      <Box sx={{ position: "relative", overflow: "hidden" }}>
        <ErrorSvg />
        <IconRain />
      </Box>
      <Box sx={{ maxWidth: "890px", textAlign: "center" }}>
        <Typography sx={{ fontWeight: 900, fontSize: { ms: "15px", md: "24px" } }}>
          We're sorry, but it seems something went wrong on our end. If the problem persists, feel
          free to contact us for assistance. We apologise for any inconvenience and appreciate your
          patience.
        </Typography>
        <Button
          disableRipple
          variant="contained"
          onClick={handleReturnClick}
          sx={{ marginTop: "40px", width: "30%", textTransform: "capitalize", fontSize: "20px" }}>
          Return
        </Button>
      </Box>
    </Grid>
  );
};

export default ErrorPage;
